import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';
import CodeableConcept from '@/fhirworks/types/CodeableConcept';

export default class AllergyIntoleranceReaction extends BackboneElement {
    static __className = 'AllergyIntoleranceReaction';

    __objectStructure = {
        manifestation: [CodeableConcept],
    };

    constructor(constructJson, className = 'AllergyIntoleranceReaction') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
